import { render, staticRenderFns } from "./roomsConfig.vue?vue&type=template&id=5bd67bbe&"
import script from "./roomsConfig.vue?vue&type=script&lang=js&"
export * from "./roomsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports